// NFT items for MutantApeYachtClub collection
export const mutantApeYachtClubNfts = [
  {
    id: "25002",
    name: "Mutant Ape #25002",
    image: "https://ipfs.io/ipfs/QmQhaRndyZWUqSam6JKFDKvDvAV3bnWncMVmRiZQsZGH4r",
    price: "2.48 ETH"
  },
  {
    id: "25897",
    name: "Mutant Ape #25897",
    image: "https://ipfs.io/ipfs/QmaZUve2DAaGtqyZXyyMHezqfLpN3jutUbL7nQ3yFZjh3r",
    price: "2.48 ETH"
  },
  {
    id: "19446",
    name: "Mutant Ape #19446",
    image: "https://ipfs.io/ipfs/QmQbsCD5qtqAyEoo4nSF9XGXZoU1uWTEcYb7FnZY7ojDqk",
    price: "2.48 ETH"
  },
  {
    id: "21444",
    name: "Mutant Ape #21444",
    image: "https://ipfs.io/ipfs/QmcaGhYt6jLY61Jk8jb4vaEChVT8gYbS8MkxqDMmHCHogx",
    price: "2.48 ETH"
  },
  {
    id: "19276",
    name: "Mutant Ape #19276",
    image: "https://ipfs.io/ipfs/QmYKeRWJ1Do4nr8YR1yfPHgckdUBRcPuXfCfz34UtCkkiR",
    price: "2.48 ETH"
  },
    
    
     {
    id: "24720",
    name: "Mutant Ape #24720",
    image: "https://ipfs.io/ipfs/QmbH21oPTfH7cHVocFAEMDh88LcEYmYuu6zC4D78hPuhGF",
    price: "2.48 ETH"
  },
  {
    id: "23674",
    name: "Mutant Ape #23674",
    image: "https://ipfs.io/ipfs/QmPPxue9QNAFVX9CGKVENQSzvBA2d2aRv5vmLpLafyo14y",
    price: "2.48 ETH"
  },
  {
    id: "26344",
    name: "Mutant Ape #26344",
    image: "https://ipfs.io/ipfs/QmccLPYCfjDuHjt2KjqowqLh9PGHe7KZm44FygBA3UAz18",
    price: "2.48 ETH"
  },
  {
    id: "13460",
    name: "Mutant Ape #13460",
    image: "https://ipfs.io/ipfs/QmdPkDRtwCjowmzp7FYNE7uFvYnCZBPW7oMFHGuDfJwfyB",
    price: "2.48 ETH"
  },
  {
    id: "23176",
    name: "Mutant Ape #23176",
    image: "https://ipfs.io/ipfs/QmQMfji3aKLsBEfCwCWFax6DLMpJnKM2dmsgJbLn2ApHnd",
    price: "2.48 ETH"
  },
  {
    id: "15805",
    name: "Mutant Ape #15805",
    image: "https://ipfs.io/ipfs/QmcPWNFeXD7gzioT1ZDL45ZsJMGHTPuW51gQqBbkopaGzt",
    price: "2.48 ETH"
  },
  {
    id: "15804",
    name: "Mutant Ape #15804",
    image: "https://ipfs.io/ipfs/QmcDDTgogJwU2SwoF65ZaMxgSrGM5A96h5WC4bpGLJ5TkU",
    price: "2.48 ETH"
  },
  {
    id: "25765",
    name: "Mutant Ape #25765",
    image: "https://ipfs.io/ipfs/QmbHtHRKKF6G1bdebrjYUZxsueeEX3u3DZBLw5SEccJTxv",
    price: "2.48 ETH"
  },
  {
    id: "13122",
    name: "Mutant Ape #13122",
    image: "https://ipfs.io/ipfs/Qmbuh8sqDMPXxZidsKecazkaVgBoQGxMfK14nJQHgmNDBJ",
    price: "2.48 ETH"
  },
  {
    id: "26654",
    name: "Mutant Ape #26654",
    image: "https://ipfs.io/ipfs/Qmbqos6hRScHb77CWGurZqDE8QL6tqbkx4YfRAe2Fo3SB6",
    price: "2.48 ETH"
  },
  {
    id: "26386",
    name: "Mutant Ape #26386",
    image: "https://ipfs.io/ipfs/Qmdq6Y5uhNACPQv7Sb1X4KmhupryA85ZVw6u5MbV9JvjhQ",
    price: "2.48 ETH"
  },
  {
    id: "20274",
    name: "Mutant Ape #20274",
    image: "https://ipfs.io/ipfs/QmdXYLFb6rRCTR7YG7f2JCeUt5kQCBicU1GpMRSF6QZbsF",
    price: "2.48 ETH"
  },
  {
    id: "29406",
    name: "Mutant Ape #29406",
    image: "https://ipfs.io/ipfs/QmcUi3kkpvYjZu8j1PEJ2Y1eYJnno4zi3RJHNEnHR1ux6o",
    price: "2.48 ETH"
  },
  {
    id: "24738",
    name: "Mutant Ape #24738",
    image: "https://ipfs.io/ipfs/QmTyvfkbEgDBwTThouaUjzo5Uu4CZSCtpPaqXCr9Wuibgo",
    price: "2.48 ETH"
  },
  {
    id: "23198",
    name: "Mutant Ape #23198",
    image: "https://ipfs.io/ipfs/QmfFd5pTb1y8Vgub3JmdVPzxRFPqiWYM2x3WHuhXWaZGfv",
    price: "2.48 ETH"
  },
  {
    id: "22050",
    name: "Mutant Ape #22050",
    image: "https://ipfs.io/ipfs/QmdtczMHZJAupTDU8BZH2rGfn5WLgSfj5UM3eXVJGy51Da",
    price: "2.48 ETH"
  },
  {
    id: "20187",
    name: "Mutant Ape #20187",
    image: "https://ipfs.io/ipfs/QmfC43Pc6Ey1wnktbQtaYqUikDnMXaKuNQcuy9sHwru7MY",
    price: "2.48 ETH"
  },
  {
    id: "27330",
    name: "Mutant Ape #27330",
    image: "https://ipfs.io/ipfs/QmZYE1GHkYa3fswcyKqT5gr7XxnpUxUCXtLKEN17ymrWRZ",
    price: "2.48 ETH"
  },
  {
    id: "29628",
    name: "Mutant Ape #29628",
    image: "https://ipfs.io/ipfs/QmP9iz8TF6VPgHG1Kg7bNqPCTZgWVUzF5nyvynVtF5kwBM",
    price: "2.48 ETH"
  },
  {
    id: "14164",
    name: "Mutant Ape #14164",
    image: "https://ipfs.io/ipfs/QmbE4wRFjPbpp6JUGfJFrR5NErkj8PxNaSPaUVQMQB4qcN",
    price: "2.48 ETH"
  },
  {
    id: "22148",
    name: "Mutant Ape #22148",
    image: "https://ipfs.io/ipfs/QmNVusrY233w9ACCdhjxA8L5FUTBmCTipn241qgCU3nteJ",
    price: "2.48 ETH"
  },
  {
    id: "22394",
    name: "Mutant Ape #22394",
    image: "https://ipfs.io/ipfs/QmYZvoe2RMyaPBewX7bdUX3itzujapXZqPsqvdrBaifYWs",
    price: "2.48 ETH"
  },
  {
    id: "16802",
    name: "Mutant Ape #16802",
    image: "https://ipfs.io/ipfs/QmYQ4ZCzU5pLdLvBrdFMpk3RLavH4YD9D6xs9JxZYcze3i",
    price: "2.48 ETH"
  },
  {
    id: "14926",
    name: "Mutant Ape #14926",
    image: "https://ipfs.io/ipfs/QmWqveELXrJoj3kTgf4NBJVUFLTsFnz3b3jPgAxoF1wqvz",
    price: "2.48 ETH"
  },
  {
    id: "12964",
    name: "Mutant Ape #12964",
    image: "https://ipfs.io/ipfs/QmVQuPJaAZa4dHxYgmv267Wqe4f7ewxEdnHdyX8inE9USE",
    price: "2.48 ETH"
  },
  {
    id: "25240",
    name: "Mutant Ape #25240",
    image: "https://ipfs.io/ipfs/QmTkWAEVt1fU8NtWjNhJycUhb84xqdQNjLbdkjujzoZ232",
    price: "2.48 ETH"
  },
  {
    id: "29318",
    name: "Mutant Ape #29318",
    image: "https://ipfs.io/ipfs/QmfKW9jUevraTTWVGmv65VCYEr135z8qhp8ECSASBnG7XK",
    price: "2.48 ETH"
  },
  {
    id: "23008",
    name: "Mutant Ape #23008",
    image: "https://ipfs.io/ipfs/QmRzKjTG9eNe4tMfupB4KS2jyeekY6wdi8tNSdfvD65DxR",
    price: "2.48 ETH"
  },
  {
    id: "11822",
    name: "Mutant Ape #11822",
    image: "https://ipfs.io/ipfs/QmesyD48u5WTN8yiM97rABMQPBdaXGfrncHytT77X2xfKt",
    price: "2.48 ETH"
  },
  {
    id: "16195",
    name: "Mutant Ape #16195",
    image: "https://ipfs.io/ipfs/QmU4JHiNXarKgnbKPbDBwbuyzKBHtfK5Rx7VtJdgxdhoFn",
    price: "2.48 ETH"
  },
  {
    id: "25528",
    name: "Mutant Ape #25528",
    image: "https://ipfs.io/ipfs/QmSvbCZ8dLWJTwxsvikQqL2GefJXUHJcnF4XV4wKgEy4oo",
    price: "2.48 ETH"
  },
  {
    id: "11118",
    name: "Mutant Ape #11118",
    image: "https://ipfs.io/ipfs/Qmba3NfKAChVGzNxynB913ArP6D5desSASPv4Pjf1ge1pL",
    price: "2.48 ETH"
  },
  {
    id: "12136",
    name: "Mutant Ape #12136",
    image: "https://ipfs.io/ipfs/QmdXjv6tsZAMku3zPW9eVX93wBDFenF5PQ2BM2LPboyJ9j",
    price: "2.48 ETH"
  },
  {
    id: "15917",
    name: "Mutant Ape #15917",
    image: "https://ipfs.io/ipfs/QmSgPJHkvGRkpM9oh2BwY9ArtBfcgy8a8xwmYvEMoXzP8t",
    price: "2.48 ETH"
  },
  {
    id: "22821",
    name: "Mutant Ape #22821",
    image: "https://ipfs.io/ipfs/QmQbUE9FP4DdhcgYti2DSHNy3PvW2eMZxiSZL9k6MAkKiu",
    price: "2.48 ETH"
  },
  {
    id: "22820",
    name: "Mutant Ape #22820",
    image: "https://ipfs.io/ipfs/QmcJH3HosMXqN8M1ZkBTZ4ADRREeZGqmHoXpGNEFAkoUyu",
    price: "2.48 ETH"
  },
  {
    id: "18882",
    name: "Mutant Ape #18882",
    image: "https://ipfs.io/ipfs/QmXYN1Ctz2ZNF3MKixjt9aiTR2ooZC8dbo798GG8vY67Js",
    price: "2.48 ETH"
  },
  {
    id: "19006",
    name: "Mutant Ape #19006",
    image: "https://ipfs.io/ipfs/QmXeKFWRX6C9s9nGncxUiYASYRC9i4z9CRidZkTfkQQJ1T",
    price: "2.48 ETH"
  },
  {
    id: "25484",
    name: "Mutant Ape #25484",
    image: "https://ipfs.io/ipfs/QmT8AwCLMk9AUDsRQEVeNp4akXiEToFAwDKSWBrt3XfSaX",
    price: "2.48 ETH"
  },
  {
    id: "12896",
    name: "Mutant Ape #12896",
    image: "https://ipfs.io/ipfs/QmXKMePr3BwkNRLiLVXG6ArTNx1qb54XrZi3SpMmzi37Sx",
    price: "2.48 ETH"
  },
  {
    id: "14149",
    name: "Mutant Ape #14149",
    image: "https://ipfs.io/ipfs/QmTusjZUFg3K7ouhMsJB1jtZaovGWZyyjF3N33sMqPWRiW",
    price: "2.48 ETH"
  },
  {
    id: "11292",
    name: "Mutant Ape #11292",
    image: "https://ipfs.io/ipfs/QmdEt1T9mWaDS1VXrVxZkgXLwaYnQHw1C8EWs2DqEW8Cm4",
    price: "2.48 ETH"
  },
  {
    id: "11760",
    name: "Mutant Ape #11760",
    image: "https://ipfs.io/ipfs/QmV2ZnnL6d3Fe6kttPtRuDvyPh6nAs3q8uU3qFoVxHDUB7",
    price: "2.48 ETH"
  },
  {
    id: "16507",
    name: "Mutant Ape #16507",
    image: "https://ipfs.io/ipfs/QmXeX6C91VnpWZ7qKiLDSjmqqGgQgsLv2JhszvykYz8wVZ",
    price: "2.48 ETH"
  },
  {
    id: "26204",
    name: "Mutant Ape #26204",
    image: "https://ipfs.io/ipfs/QmR8VV7z52jroDWAtiJk5RSXPohKUwUY7xbY8MjkCVrTb3",
    price: "2.48 ETH"
  },
    
      {
    id: "11881",
    name: "Mutant Ape #11881",
    image: "https://ipfs.io/ipfs/QmNr4FpN1Akf3BMk9Xo5weBLnEM6SLHV5eoCYaBasfxogF",
    price: "2.48 ETH"
  },
  {
    id: "29550",
    name: "Mutant Ape #29550",
    image: "https://ipfs.io/ipfs/QmPtmm8Ex916LXMv1exEgMuxGBUaiz5k82zvoHWHS9EfLL",
    price: "2.48 ETH"
  },
  {
    id: "16420",
    name: "Mutant Ape #16420",
    image: "https://ipfs.io/ipfs/QmfU89wwK4XE3PmL591g3epKDFtEuUCLfw8wX1djGcFuRH",
    price: "2.48 ETH"
  },
  {
    id: "27144",
    name: "Mutant Ape #27144",
    image: "https://ipfs.io/ipfs/QmVfhYr2tu29xFPMrFfZZiCmfPVbSfh21oS5aR9CRMhar2",
    price: "2.48 ETH"
  },
  {
    id: "28009",
    name: "Mutant Ape #28009",
    image: "https://ipfs.io/ipfs/QmWJ9dHayfXyGoHGmBZGpRtXapA2MxEFNzoQp4TBwv7tdg",
    price: "2.48 ETH"
  },
  {
    id: "12254",
    name: "Mutant Ape #12254",
    image: "https://ipfs.io/ipfs/QmVz565Ahpsi8HHWqQo8zk7SRMA9p8n9eZfA4VkcdzNzxg",
    price: "2.48 ETH"
  },
  {
    id: "20488",
    name: "Mutant Ape #20488",
    image: "https://ipfs.io/ipfs/QmRwMLGzXSR1j4pqqzfnXsjjiAAxnwREhV2UtLVvZK7WSE",
    price: "2.48 ETH"
  },
  {
    id: "16506",
    name: "Mutant Ape #16506",
    image: "https://ipfs.io/ipfs/QmUU4WztddW4nqppQmzTTgw998Khf6KYkyFf7BFiCW8gBq",
    price: "2.48 ETH"
  },
  {
    id: "20776",
    name: "Mutant Ape #20776",
    image: "https://ipfs.io/ipfs/QmfZpQyrM8cbyJBtDz2HVUbvaYXzQT9ayC7MpzVr8MZNb9",
    price: "2.48 ETH"
  },
  {
    id: "16340",
    name: "Mutant Ape #16340",
    image: "https://ipfs.io/ipfs/QmWPeMEU6Ajr5fx3SXipYvGpJKAobAnSeUtxMR2RU17ca8",
    price: "2.48 ETH"
  },
  {
    id: "25447",
    name: "Mutant Ape #25447",
    image: "https://ipfs.io/ipfs/QmV46udn29rLXD6Tk6Ucgqp3gpAvfJwqYLC7tcWhNSqGTS",
    price: "2.48 ETH"
  },
  {
    id: "19356",
    name: "Mutant Ape #19356",
    image: "https://ipfs.io/ipfs/QmRh4yYDwn8YwLryaFzBvsFxoBeg81kKhWZYUPh6H6BY3q",
    price: "2.48 ETH"
  },
  {
    id: "27910",
    name: "Mutant Ape #27910",
    image: "https://ipfs.io/ipfs/QmVj7er326is4gJVW2PFEdn7XPWw8cezmQZgJFFqDWLMXT",
    price: "2.48 ETH"
  },
  {
    id: "19984",
    name: "Mutant Ape #19984",
    image: "https://ipfs.io/ipfs/QmTJL6qNFV6ibnmgstSkA3zvDc4uUzWcKBDbfFtGTyiEf5",
    price: "2.48 ETH"
  },
  {
    id: "17025",
    name: "Mutant Ape #17025",
    image: "https://ipfs.io/ipfs/QmXgAuVxUjDFAzNrRiSWQGZHvhDUojSKDELvruLJ76pasB",
    price: "2.48 ETH"
  },
  {
    id: "28702",
    name: "Mutant Ape #28702",
    image: "https://ipfs.io/ipfs/QmTtBYnmesiUJGHkAvrCQXt8BzgUBEEUUxreQEs8uRbpZa",
    price: "2.48 ETH"
  },
  {
    id: "21218",
    name: "Mutant Ape #21218",
    image: "https://ipfs.io/ipfs/QmTtt7xUeFtBBYgZrfbaCfwYzFmgDSgG8ewcnFGdpipxmt",
    price: "2.48 ETH"
  },
  {
    id: "22370",
    name: "Mutant Ape #22370",
    image: "https://ipfs.io/ipfs/QmREP4D7ek4ZvMiy4K2A1eFG1Vw1b6e1KL2UoajfWae3DN",
    price: "2.48 ETH"
  },
  {
    id: "17008",
    name: "Mutant Ape #17008",
    image: "https://ipfs.io/ipfs/QmUFVt73RRpmXSjx5Yof12KrjMHdET2Ee46AxXuRZnJ6h6",
    price: "2.48 ETH"
  },
  {
    id: "18583",
    name: "Mutant Ape #18583",
    image: "https://ipfs.io/ipfs/Qmcy3NTn74YDc1yTjmNbP1rUfS4Fywfd7DWDTmt9TcFb74",
    price: "2.48 ETH"
  },
  {
    id: "23344",
    name: "Mutant Ape #23344",
    image: "https://ipfs.io/ipfs/QmZN1cvGHTgpePLfzqVbMStDnYzYvKSHZekNcXyDJvfpjU",
    price: "2.48 ETH"
  },
  {
    id: "12915",
    name: "Mutant Ape #12915",
    image: "https://ipfs.io/ipfs/QmYCz72oxxSYMCuFXoheiFaGYfRJEcAUG5B1mXVLTyB2c1",
    price: "2.48 ETH"
  },
  {
    id: "11232",
    name: "Mutant Ape #11232",
    image: "https://ipfs.io/ipfs/QmdqYc1UxGMTRGLYYXqEQpLdsaXBow7PVCNbBEjPRvg5VX",
    price: "2.48 ETH"
  },
  {
    id: "25678",
    name: "Mutant Ape #25678",
    image: "https://ipfs.io/ipfs/QmS6vuXcU39igVHa9VJthrjbWVGejWqy8gkpxpSkKicm2s",
    price: "2.48 ETH"
  },
  {
    id: "11566",
    name: "Mutant Ape #11566",
    image: "https://ipfs.io/ipfs/QmRTTXzoVQsQYsut4EqtNUXmySZstbyYntGuahFBw3u1Wn",
    price: "2.48 ETH"
  },
  {
    id: "12914",
    name: "Mutant Ape #12914",
    image: "https://ipfs.io/ipfs/QmPTbzUBiJFkbbvdXhjnC4XBRLjaFuKAc47qRPiHM4Jg8U",
    price: "2.48 ETH"
  },
  {
    id: "20464",
    name: "Mutant Ape #20464",
    image: "https://ipfs.io/ipfs/QmeEyFq7D4XHT5cGArGyn8ku2edVV3Nbh65hQHpWaspMUm",
    price: "2.48 ETH"
  },
  {
    id: "12714",
    name: "Mutant Ape #12714",
    image: "https://ipfs.io/ipfs/Qme8DBPjzSgoJnpMFn1EWgYPuxGevPTvT7vMitizHVzTrB",
    price: "2.48 ETH"
  },
  {
    id: "27016",
    name: "Mutant Ape #27016",
    image: "https://ipfs.io/ipfs/Qmd2dh9U5Gdzu4FqpoBgLYKSreHpUuwvgYt6PS9CMME5np",
    price: "2.48 ETH"
  },
  {
    id: "23442",
    name: "Mutant Ape #23442",
    image: "https://ipfs.io/ipfs/QmYY2hDCiydAaLZjeef9AqZaqNr1GuJkMK1RJmNsi8AJME",
    price: "2.48 ETH"
  },
  {
    id: "13068",
    name: "Mutant Ape #13068",
    image: "https://ipfs.io/ipfs/QmNNgiwBph3W84T99zwNNEi4daubgffksAdgxeGR2qG7ej",
    price: "2.48 ETH"
  },
  {
    id: "24189",
    name: "Mutant Ape #24189",
    image: "https://ipfs.io/ipfs/QmVxkzRqsU4YeRWUXdpcaioFFKu8qjHWtdC7S4QcybCUcA",
    price: "2.48 ETH"
  },
  {
    id: "24188",
    name: "Mutant Ape #24188",
    image: "https://ipfs.io/ipfs/QmbsBK6VcMmRj7mSJkVmU57QHJ44q3MQ5JPfuuz4gGCeaX",
    price: "2.48 ETH"
  },
  {
    id: "14235",
    name: "Mutant Ape #14235",
    image: "https://ipfs.io/ipfs/QmaorVrCSu5VmUcuDFMT6GwqcTdqLvWLgu7NghmkWELmvp",
    price: "2.48 ETH"
  },
  {
    id: "25438",
    name: "Mutant Ape #25438",
    image: "https://ipfs.io/ipfs/QmQ7URuFKUsiqJLtVS2eMDqopDWXLRLB3GCrxNRg22mfuG",
    price: "2.48 ETH"
  },
  {
    id: "15529",
    name: "Mutant Ape #15529",
    image: "https://ipfs.io/ipfs/QmQyDyLLRPPVFCcwfKHZFeuHDysHW5a1JxYevX1aBn9dAK",
    price: "2.48 ETH"
  },
  {
    id: "20174",
    name: "Mutant Ape #20174",
    image: "https://ipfs.io/ipfs/QmZsJDtNYXD5VQshkZwX9DiNifPWYtyexvoo8fesXnkQrS",
    price: "2.48 ETH"
  },
  {
    id: "21791",
    name: "Mutant Ape #21791",
    image: "https://ipfs.io/ipfs/QmZBvc3dXciAJURPs4tGhBgdBdAy4wkM33VMQA1r9XzEpv",
    price: "2.48 ETH"
  },
  {
    id: "21790",
    name: "Mutant Ape #21790",
    image: "https://ipfs.io/ipfs/QmY9hqRK8dGxssezKnHGrgpExuFbQrqq2AnWYt7rGREdRj",
    price: "2.48 ETH"
  },
  {
    id: "16324",
    name: "Mutant Ape #16324",
    image: "https://ipfs.io/ipfs/QmVrKYamVb7vxuyULL2Q1d9eueKTxW5cNK2izLBE277z1r",
    price: "2.48 ETH"
  },
  {
    id: "20668",
    name: "Mutant Ape #20668",
    image: "https://ipfs.io/ipfs/QmUt5i25JZcKv5PUmLNG8KsuVPnntrH1DFSD2okv4Bdqr4",
    price: "2.48 ETH"
  },
  {
    id: "26803",
    name: "Mutant Ape #26803",
    image: "https://ipfs.io/ipfs/QmaFzY2NaDuYkqQhHLD7P4qwJ54W7Q9xnxyKR64n3npVRD",
    price: "2.48 ETH"
  },
  {
    id: "14120",
    name: "Mutant Ape #14120",
    image: "https://ipfs.io/ipfs/QmbuypGvnJVs6CUu91zc3qDoW6wLxate7axQJXKFUH4EJo",
    price: "2.48 ETH"
  },
  {
    id: "13211",
    name: "Mutant Ape #13211",
    image: "https://ipfs.io/ipfs/QmeuGFD8QFKmWySghQKGA2DLNh3mdhW45tkQCpHWHGD2cs",
    price: "2.48 ETH"
  },
  {
    id: "13210",
    name: "Mutant Ape #13210",
    image: "https://ipfs.io/ipfs/Qmb3xMsuWSWUGKg9iS8Fu9HEodaJuXEuxFUJPeirCCQg6p",
    price: "2.48 ETH"
  },
  {
    id: "11517",
    name: "Mutant Ape #11517",
    image: "https://ipfs.io/ipfs/QmXr46GufXoYT6iw5oTA1XWRKX63CpqRi3DsMtFJSqT1rh",
    price: "2.48 ETH"
  },
  {
    id: "29350",
    name: "Mutant Ape #29350",
    image: "https://ipfs.io/ipfs/QmYUtcMxiaqn1kSdyKdLmM9cebaLoY57F22Cd9TWTMpVL4",
    price: "2.48 ETH"
  },
  {
    id: "24854",
    name: "Mutant Ape #24854",
    image: "https://ipfs.io/ipfs/QmbPUThoCdch5rGhHVHFrtEBYqSUhANHjDXR9RuqHrvp9X",
    price: "2.48 ETH"
  },
  {
    id: "26014",
    name: "Mutant Ape #26014",
    image: "https://ipfs.io/ipfs/QmUp2wSUEqW9wnsm7LLZPXuGkTyj1eaLbPwcyknubFdiPC",
    price: "2.48 ETH"
  },
  {
    id: "18051",
    name: "Mutant Ape #18051",
    image: "https://ipfs.io/ipfs/QmdGf9vHjwduDU2UziErVd4mVWzoxUP1hEG85rWSkRCUAc",
    price: "2.48 ETH"
  }
    
    
    
];
